import React, { useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
import classes from "./HomePageV1Mobile.module.css";
import Fonts from "../../../stories/assets/Fonts";
import {
    logoColor,
    ArrowUpRightBlue,
    TennisForV1,
    GolfForV1,
    SoccerForV1,
    BaseballForV1,
    BasketballForV1,
    SkatesForV1,
    FootballForV1,
} from "../../../constant/imagePath";
import Colors from "../../../stories/assets/Colors";
import { MobileHeader } from "../../../stories/MobileHeader/MobileHeader";
import { Input } from "../../../stories/Input/Input";
import { Button } from "../../../stories/Button/Button";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import { PlayCard } from "../../../stories/PlayCard/PlayCard";
import { MobileFooter } from "../../../stories/MobileFooter/MobileFooter";
import HomePageFilter from "../../../components/Modals/StudentFlow/HomePageFilter/HomePageFilter";
import { useHistory } from "react-router-dom";

export default function HomePageMobile() {
    const history = useHistory();
    const [search, setSearch] = useState();
    const [showFilterModal, setShowFilterModal] = useState(false);

    const [playcard, setPlaycard] = useState([
        {
            icon: TennisForV1,
            title: "Tennis",
            value: "1 283 coaches",
            selectedData: "",
            showSelection: false,
        },
        {
            icon: FootballForV1,
            title: "Football",
            value: "Comming soon",
            selectedData: "",
            showSelection: false,
        },
        {
            icon: GolfForV1,
            title: "Football",
            value: "Comming soon",
            selectedData: "",
            showSelection: false,
        },
        {
            icon: SoccerForV1,
            title: "Soccer",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
        },
        {
            icon: BaseballForV1,
            title: "Baseball",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
        },
        {
            icon: BasketballForV1,
            title: "Basketball",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
        },
        {
            icon: SkatesForV1,
            title: "Basketball",
            value: "Coming soon",
            selectedData: "",
            showSelection: false,
        },
    ]);

    // getSearchDataHandler
    const getSearchDataHandler = (data) => {
        setSearch(`${data.sports} ${data.location.address} ${data.date}`);
    };
    return (
        <div>
            <section className={[classes.homeBanner].join(" ")}>
                <Container fluid className={["p-0"].join(" ")}>
                    <MobileHeader
                        isLogo={true}
                        logo={logoColor}
                        customStyle={{ marginBottom: "24px" }}
                    />
                    <div>
                        <p
                            style={{
                                ...Fonts.h1,
                                color: Colors.white,
                                fontSize: "29px",
                                lineHeight: "36px",
                            }}
                            className={[classes.contentWidth, classes.mb16].join(" ")}
                        >
                            GET POWERFUL WORKOUTS WITH PROFESSIONAL COACHES
                        </p>
                        <div className={[classes.mb16].join(" ")}>
                            <Input
                                state={search}
                                // setter={setSearch}
                                placeholder="Sport type, technique, coach name..."
                                onFocus={(e) => {
                                    setShowFilterModal(true);
                                    e.target.blur();
                                }}
                            />
                        </div>
                        <div className={[classes.mb32].join(" ")}>
                            <Button
                                label="Search"
                                primary={true}
                                customStyle={{ ...Fonts.b1, width: "100%" }}
                            />
                        </div>
                        <div className={[classes.bannerButton].join(" ")}>
                            <LinkButtonWithIcon
                                text={"Get a Match"}
                                rightIcon={ArrowUpRightBlue}
                                iconStyle={{ marginLeft: "5px" }}
                                primary={true}
                            />
                        </div>
                    </div>
                </Container>
            </section>
            <section className={[classes.middleSection].join(" ")}>
                <div>
                    <p
                        style={{
                            ...Fonts.h3,
                            fontSize: "24px",
                            lineHeight: "32px",
                            color: Colors.neutralShadesOfNero,
                        }}
                        className={[classes.mb24].join(" ")}
                    >
                        Explore different sports
                    </p>
                </div>
                <div className={classes.playCardMainDiv}>
                    {playcard?.map((item, i) => {
                        return (
                            <div className={[classes.playCardDiv].join(" ")}>
                                <PlayCard
                                    icon={item.icon}
                                    title={item.title}
                                    value={item.value}
                                    // titleStyle={{ textAlign: "left" }}
                                    valueStyle={{ whiteSpace: 'nowrap', color: Colors.neutralShadesOfDimGray, ...Fonts.p2 }}
                                    iconStyle={{ width: '48px', height: '48px', margin: '0 auto' }}
                                />
                            </div>
                        );
                    })}
                </div>
            </section>
            <MobileFooter />



            <HomePageFilter
                show={showFilterModal}
                setShow={setShowFilterModal}
                playcard={playcard}
                getSearchDataHandler={getSearchDataHandler}
            />
        </div>
    );
}
